import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";

import Notificacao from "../../components/Notificacao";
import { getLoggedInUser } from "../../helpers/authUtils";

import moment from "moment";
import { connect } from "react-redux";
// import { Libfirebase } from '../../Libs/firebase';
import Comentario from "../../components/Comentario";
import ListStatus from "../ListStatus";
import ModalComponent from "../Modal";
import Input from "../../components/Input";


import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from "../../helpers/firebase-config";

class Historico extends Component {
  state = {
    comentario: "",
    ref: null,
    alertMsg: null,
    idPaciente: "",
    id: "",

  };


  componentDidMount() {
    const { idPaciente, item } = this.props;
    this.setState({ idPaciente: idPaciente });
    this.setState({ id: item.id });


    const id = item.id;

    var that = this;

    let refPaciente = Libfirebase.collection("paciente").doc(idPaciente);

    let ref = Libfirebase.collection("paciente")
      .doc(idPaciente)
      // .collection("historico")
      // .doc(id)
      .collection("Comentarios");

    // var unsubscribe = ref.orderBy("data", "desc").onSnapshot(snap => {
    //   let listComentario = [];

    //   snap.forEach(doc => {
    //     doc
    //       .data()
    //       .refProfissional.get()
    //       .then(prof => {
    //         const data = {
    //           id: doc.id,
    //           comentario: doc.data(),
    //           profissional: prof.data(),
    //           idProfissional: prof.id
    //         };

    //         listComentario.push(data);
    //         that.setState({
    //           listComentario: listComentario.sort((a, b) => {

    //             return (
    //               parseInt(a.comentario.dataHoraCriacao) -
    //               parseInt(b.comentario.dataHoraCriacao)
    //             );
    //           })
    //         });
    //       });
    //   });
    // });

    that.setState({ ref });
  }

  _setComentario = () => {
    const { comentario, ref } = this.state;
    //const { profissional } = this.props.item;

    const profissional = getLoggedInUser();
    this.setState({ notifition: false });
    const refProfissional = Libfirebase.collection("usuario").doc(
      profissional.cpf
    );
    if (comentario) {
      ref
        .add({
          comentario,
          refProfissional,
          dataHoraCriacao: moment().format("DDMMYYYYHHmmss"),
          data: moment().format("YYYY-MM-DD HH:mm:ss")
        })
        .then(() => {
          alert(1);
          this.setState({
            openModal: true,
            comentario: "",
            notifition: true,
            msg: "Comentário inserido com sucesso3!",
            nameclass: "alert-success"
          });
        })
        .catch(error => {
          this.setState({
            notifition: true,
            msg: error.code,
            nameclass: "alert-danger"
          });
        });
    } else {
      this.setState({
        notifition: true,
        msg: "Favor preencher o comentário!",
        nameclass: "alert-warning"
      });
    }
  };

  componentWillUnmount() {
    const { unsubscribe } = this.state;

    unsubscribe();
  }

  _setStatus = value => {
    const { idPaciente, id } = this.props.item;
    const { refPaciente } = this.state;
    this.setState({ status: value, notifition: false, msg: "", nameclass: "" });
    this.props.item.historico.status = value;
    var that = this;

    refPaciente
      .update({ status: value })
      .then(() => {
        Libfirebase.collection("paciente")
          .doc(idPaciente)
          .collection("historico")
          .doc(id)
          .update({ status: value })
          .then(() => {
            that.setState({
              openModal: false,
              notifition: true,
              msg: "Status alterado com sucesso!",
              nameclass: "alert-success"
            });
          })
          .catch(error => {
            that.setState({
              openModal: false,
              status: null,
              notifition: true,
              msg: "Houve um erro ao salvar o status",
              nameclass: "alert-danger"
            });
          });
      })
      .catch(error => {
        that.setState({
          openModal: false,
          status: null,
          notifition: true,
          msg: "Houve um erro ao salvar o status",
          nameclass: "alert-danger"
        });
      });
  };

  render() {

    return (
      <div>

        {this.props.aba !== "Risco Cirúrgico" ? (
          <div
            className="container"
            style={{
              overflowY: "scroll",
              overflowX: "hidden",
              maxHeight: "80vh"
            }}
          >
            <div className="row">
              <div className="col-s12">
                <label>Especialidade: </label>{" "}
                {this.props.item.historico.especialidade}
              </div>
            </div>

            <div className="row">
              <div className="col-s12">
                <label>Queixa Principal: </label>{" "}
                {ReactHtmlParser(this.props.item.historico.queixa)}
              </div>
            </div>

            <div className="row">
              <div className="col-s12">
                <label>Historico da Moléstia Principal: </label>{" "}
                {ReactHtmlParser(this.props.item.historico.historico)}
              </div>
            </div>

            <div className="row">
              <div className="col-s12">
                <label>Exames: </label>{" "}
                {ReactHtmlParser(this.props.item.historico.exames)}
              </div>
            </div>

            <div className="row">
              <div className="col-s12">
                <label> Observação: </label>{" "}
                {ReactHtmlParser(this.props.item.historico.Observacao)}
              </div>
            </div>

            <div className="row">
              <label> Anexos:</label>

              {this.props.item.listMidia && this.props.item.listMidia != "undefined" ? (
                <div className="row">
                  {this.props.item.listMidia.map(midia => {
                    return (
                      <div
                        className="col-md-4"
                        key={midia.id}
                        style={{ marginBottom: 20 }}
                      >
                        <a href={midia.midia.url} target="_blank">
                          <img src={midia.midia.url} className="img-fluid" />
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (
                "Sem anexos!"
              )}
            </div>

            <div className="row">
              <div className="col-s12">
                <ListStatus
                  change={event => this._setStatus(event.target.value)}
                  status={this.props.item.historico.status}
                />
                {this.state.status === "Acompanhamento Ambulatorial" ||
                  this.state.status === "Acompanhamento Pós Operatório" ? (
                  <Input
                    label="Data de Retorno*:"
                    placeholder="Data de Retorno"
                    type="date"
                    id="dataRetorno"
                    value={this.state.dataRetorno}
                    onChange={text => this.setState({ dataRetorno: text })}
                    icone="fa fa-calendar"
                  />
                ) : null}

              </div>
            </div>
            {this.state.notifition ? (
              <Notificacao
                msg={this.state.msg}
                nameclass={this.state.nameclass}
              />
            ) : null}

            <Comentario
              teste={"Chapéu"}
              comentario={this.state.listComentario}
              usuario={this.props.usuario}
              _setComentario={this._setComentario}
              _setStateComentario={comentario => {
                this.setState({ comentario });
              }}
              Txtcomentario={this.state.comentario}
            />

            <ModalComponent
              openModal={this.state.openModal}
              closeModal={() => this.setState({ openModal: false })}
            >
              <h2>Deseja atualizar o status do histórico? 2</h2>
              <p>
                Apenas alterando o status que os outros profissionais saberão do
                seu comentário!
              </p>
              <ListStatus
                status={this.state.status}
                change={event => this.setState({ status: event.target.value })}
              />
              <div style={{ float: "right" }}>
                <button
                  style={{ float: "left" }}
                  onClick={() => this._setStatus(this.state.status)}
                  type="button"
                  className="btn waves-effect waves-light btn-success"
                >
                  Alterar Status
                </button>
                <button
                  style={{ float: "left" }}
                  onClick={() => this.setState({ openModal: false })}
                  type="button"
                  className="btn waves-effect waves-light btn-danger"
                >
                  Cancelar
                </button>
              </div>
            </ModalComponent>
          </div>
        ) : (
          <div
            className="container"
            style={{
              overflowY: "scroll",
              overflowX: "hidden",
              maxHeight: "80vh"
            }}
          >
            <div className="row">
              <div className="col-s12">
                <label>Especialidade: </label>{" "}
                {this.props.item.historico.especialidade}
              </div>
            </div>
            <div className="row">
              <div className="col-s12">
                <label> Observação: </label>{" "}
                {ReactHtmlParser(this.props.item.historico.Observacao)}
              </div>
            </div>

            <div className="row">
              <label> Anexos:</label>

              {this.props.item.listMidia ? (
                <div className="row">
                  {this.props.item.listMidia.map(midia => {
                    return (
                      <div
                        className="col-md-4"
                        key={midia.id}
                        style={{ marginBottom: 20 }}
                      >
                        <a href={midia.midia.url} target="_blank">
                          <img src={midia.midia.url} className="img-fluid" />
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (
                "Sem anexos!"
              )}
            </div>

            <div className="row">
              <div className="col-s12">
                <ListStatus
                  change={event => this._setStatus(event.target.value)}
                  status={this.props.item.historico.status}
                />
              </div>
            </div>
            {this.state.notifition ? (
              <Notificacao
                msg={this.state.msg}
                nameclass={this.state.nameclass}
              />
            ) : null}

            <Comentario
              teste={"Chapéu"}
              comentario={this.state.listComentario}
              usuario={this.props.usuario}
              _setComentario={this._setComentario}
              _setStateComentario={comentario => {
                this.setState({ comentario });
              }}
              Txtcomentario={this.state.comentario}
            />

            <ModalComponent
              openModal={this.state.openModal}
              closeModal={() => this.setState({ openModal: false })}
            >
              <h2>Deseja atualizar o status do histórico? 3</h2>
              <p>
                Apenas alterando o status que os outros profissionais saberão do
                seu comentário!
              </p>
              <ListStatus
                status={this.state.status}
                change={event => this.setState({ status: event.target.value })}
              />

              <div style={{ float: "right" }}>
                <button
                  style={{ float: "left" }}
                  onClick={() => this._setStatus(this.state.status)}
                  type="button"
                  className="btn waves-effect waves-light btn-success"
                >
                  Alterar Status
                </button>
                <button
                  style={{ float: "left" }}
                  onClick={() => this.setState({ openModal: false })}
                  type="button"
                  className="btn waves-effect waves-light btn-danger"
                >
                  Cancelar
                </button>
              </div>
            </ModalComponent>
          </div>
        )}
      </div>
    );
  }
}

export default connect()(Historico);
